import { render, staticRenderFns } from "./CommercialOperationBadge.vue?vue&type=template&id=e61a6c76"
import script from "./CommercialOperationBadge.vue?vue&type=script&lang=js"
export * from "./CommercialOperationBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports